import React from 'react'
import { observer } from 'mobx-react-lite'

import { SyncLogsScreenBase } from './SyncLogsScreen'

import { useStore } from '../hooks/storeHook'

export const MoySkladSyncLogsScreen =
  observer(() => {
    const {syncStore: {moySkladAccount}} = useStore()

    return moySkladAccount ? <SyncLogsScreenBase account={moySkladAccount}/>
                           : null

  })